module.exports = __webpack_public_path__ + "dd71c2791a21ecf93b932d097176373f.pdf";